import React, { useRef } from 'react';

// Demo data for testing when obj is empty
const DaoCardGenerator = ({ obj = {} }) => {
    const cardRef = useRef(null);

    // Tạo dữ liệu mẫu nếu không có obj
    const demoData = {
        id: '00108',
        ma: '00108',
        ten: 'NGUYỄN THỊ THÚY NHUNG',
        ngay_sinh: '15/05/1980',
        gioitinh_fk: 2,
        cccd: '001234567890',
        dien_thoai: '0909123456',
        nhadan_fk: 'Nhà Đàn Tây Ninh',
        dia_chi: '123 Đường ABC',
        city_code: 'TP.HCM',
        country_fk: '380',
        anhdaidien: null
    };

    // Sử dụng obj nếu có, không thì dùng demoData
    const cardData = Object.keys(obj).length > 0 ? obj : demoData;

    // Hàm tạo QR code URL - chỉ chứa ID
    const generateQRCode = (data) => {
        const qrData = data?.id || '00108';
        return `https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=${encodeURIComponent(qrData)}`;
    };

    // Hàm tạo HTML cho thẻ đạo
    const createCardHTML = () => {
        return `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Thẻ Đạo - ${cardData?.ten || 'Đạo hữu'}</title>
          <style>
            body { 
              margin: 0; 
              padding: 20px; 
              font-family: Arial, sans-serif;
              background: #f5f5f5;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
            }
            .dao-card {
              width: 340px;
              height: 215px;
              background: radial-gradient(circle at 20% 30%, rgba(255,223,0,0.3) 0%, transparent 50%),
                         radial-gradient(circle at 80% 70%, rgba(255,165,0,0.3) 0%, transparent 50%),
                         radial-gradient(circle at 40% 80%, rgba(255,215,0,0.2) 0%, transparent 50%),
                         linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%);
              border: 2px solid #B8860B;
              border-radius: 10px;
              font-family: Arial, sans-serif;
              position: relative;
              overflow: hidden;
              box-shadow: 0 4px 8px rgba(0,0,0,0.3);
              padding: 6px;
              display: flex;
              flex-direction: column;
            }
            .pattern-overlay {
              position: absolute;
              top: 0; left: 0; right: 0; bottom: 0;
              background-image: 
                radial-gradient(circle at 15% 15%, rgba(255,255,255,0.08) 3px, transparent 3px),
                radial-gradient(circle at 45% 25%, rgba(255,255,255,0.06) 2px, transparent 2px),
                radial-gradient(circle at 75% 35%, rgba(255,255,255,0.08) 3px, transparent 3px),
                radial-gradient(circle at 25% 55%, rgba(255,255,255,0.06) 2px, transparent 2px),
                radial-gradient(circle at 85% 65%, rgba(255,255,255,0.08) 3px, transparent 3px),
                radial-gradient(circle at 35% 85%, rgba(255,255,255,0.06) 2px, transparent 2px),
                radial-gradient(circle at 65% 75%, rgba(255,255,255,0.08) 3px, transparent 3px),
                linear-gradient(30deg, transparent 30%, rgba(255,255,255,0.02) 31%, rgba(255,255,255,0.02) 33%, transparent 34%),
                linear-gradient(60deg, transparent 30%, rgba(255,255,255,0.02) 31%, rgba(255,255,255,0.02) 33%, transparent 34%),
                linear-gradient(90deg, transparent 30%, rgba(255,255,255,0.02) 31%, rgba(255,255,255,0.02) 33%, transparent 34%);
              background-size: 40px 40px, 35px 35px, 40px 40px, 35px 35px, 40px 40px, 35px 35px, 40px 40px, 25px 25px, 25px 25px, 25px 25px;
              pointer-events: none;
              opacity: 0.4;
            }
            .lotus-overlay {
              position: absolute;
              top: 0; left: 0; right: 0; bottom: 0;
              background-image: 
                radial-gradient(ellipse 8px 4px at 50% 50%, rgba(255,255,255,0.05), transparent),
                radial-gradient(ellipse 4px 8px at 50% 50%, rgba(255,255,255,0.05), transparent);
              background-size: 20px 20px, 20px 20px;
              background-position: 0 0, 10px 10px;
              pointer-events: none;
              opacity: 0.3;
              transform: rotate(45deg);
            }
            @media print {
              body { 
                margin: 0; 
                padding: 0; 
                background: white;
                min-height: auto;
              }
            }
          </style>
        </head>
        <body>
          <div class="dao-card">
            <div class="pattern-overlay"></div>
            <div class="lotus-overlay"></div>
            
            <!-- Header -->
            <div style="text-align: center; font-size: 12px; font-weight: bold; color: #FFD700; text-shadow: 1px 1px 2px rgba(0,0,0,0.8), 0 0 3px rgba(0,0,0,0.5); margin-bottom: 1px; text-transform: uppercase; letter-spacing: 0.3px; line-height: 1.1;">
              ĐẠI ĐẠO TAM KỲ CHIẾU MINH<br/>HUỲNH ĐẠO VÔ VI
            </div>
            
            <!-- Certificate -->
            <div style="text-align: center; font-size: 11px; font-weight: bold; color: #DC143C; margin-bottom: 6px; text-shadow: 1px 1px 2px rgba(0,0,0,0.5);">
              CHỨNG NHẬN / CERTIFICATE
            </div>

            <!-- Main Layout -->
            <div style="display: flex; align-items: flex-start; gap: 10px; flex: 1;">
              <!-- Photo -->
              <div style="width: 85px; display: flex; flex-direction: column; align-items: center;">
                <div style="width: 78px; height: 104px; border: 1px solid #8B4513; border-radius: 4px; background-color: #fff; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                  ${cardData?.anhdaidien ?
            `<img src="${cardData.anhdaidien}" alt="Avatar" style="width: 100%; height: 100%; object-fit: cover;" />` :
            `<div style="font-size: 11px; color: #666; text-align: center;">Ảnh<br/>3x4</div>`
        }
                </div>
              </div>

              <!-- Info -->
              <div style="flex: 1; display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
                <!-- Top Info Section -->
                <div>
                  <!-- Name -->
                  <div style="font-size: 15px; font-weight: bold; color: #1B365D; text-align: center; margin-bottom: 5px; text-transform: uppercase; letter-spacing: 0.5px;">
                    ${cardData?.ten || 'MAI THỊ DIỄM'}
                  </div>

                  <!-- Title -->
                  <div style="font-size: 12px; font-weight: bold; color: #FFD700; text-align: center; margin-bottom: 4px; text-shadow: 1px 1px 2px rgba(0,0,0,0.6);">
                    Đạo hữu
                  </div>

                  <!-- Subtitle -->
                  <div style="font-size: 11px; font-weight: bold; color: #FFD700; text-align: center; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.8px; text-shadow: 1px 1px 2px rgba(0,0,0,0.6);">
                    HUỲNH CƠ ĐẠI ĐẠO TAM KỲ
                  </div>
                </div>

                <!-- Middle Section - ID & QR Box -->
                <div style="display: flex; justify-content: center; margin-bottom: 8px;">
                  <div style="border: 1px solid #8B4513; border-radius: 6px; background: linear-gradient(90deg, #ffffff 0%, #f8f8f8 25%, #f0f0f0 50%, #e8e8e8 75%, #e0e0e0 100%); padding: 4px 10px; display: flex; align-items: center; justify-content: center; gap: 8px; height: 38px; width: 130px; box-shadow: inset 0 1px 3px rgba(0,0,0,0.15), 0 1px 2px rgba(255,255,255,0.8);">
                    <div style="display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                      <span style="font-size: 10px; color: #555;">Số hiệu:</span>
                      <span style="font-size: 13px; font-weight: bold; color: #333;">${cardData?.id || '3477'}</span>
                    </div>
                    <div style="width: 34px; height: 34px; background-color: #fff; border-radius: 3px; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc;">
                      <img src="${generateQRCode(cardData)}" alt="QR Code" style="width: 32px; height: 32px;" />
                    </div>
                  </div>
                </div>

                <!-- Bottom Text -->
                <div style="font-size: 8px; color: #8B4513; text-align: center; line-height: 1.2; font-style: italic; margin-top: auto;">
                  "Thẻ này dùng để tra cứu thông tin Tu học và sinh hoạt Đạo sự"
                </div>
              </div>
            </div>
          </div>
        </body>
      </html>
    `;
    };

    // Hàm mở thẻ trong tab mới
    const openCardInNewTab = () => {
        const cardHTML = createCardHTML();
        const newWindow = window.open('', '_blank');
        if (newWindow) {
            newWindow.document.write(cardHTML);
            newWindow.document.close();
        }
    };

    // Hàm in thẻ
    const printCard = () => {
        const cardHTML = createCardHTML();
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write(cardHTML);
            printWindow.document.close();
            printWindow.print();
        }
    };

    return (
        <div className="dao-card-generator" style={{ display: 'inline-block' }}>
            {/* Buttons với style giống nhau và cùng kích thước */}
            <button
                className="btn btn-primary mr-1"
                onClick={openCardInNewTab}
                style={{
                    marginRight: '10px',
                    minWidth: '120px',
                    height: '38px',
                    fontSize: '14px'
                }}
            >
                <i className="fa fa-id-card"></i> Xem Thẻ Đạo
            </button>
            <button
                className="btn btn-success mr-1"
                onClick={printCard}
                style={{
                    minWidth: '120px',
                    height: '38px',
                    fontSize: '14px'
                }}
            >
                <i className="fa fa-print"></i> In Thẻ Đạo
            </button>
        </div>
    );
};

export default DaoCardGenerator;